import React from 'react';
import { Hero } from '../components/Hero';
import { StatsBar } from '../components/StatsBar';
import { ProblemSection } from '../components/ProblemSection';
import { NoPdfSection } from '../components/NoPdfSection';
import { BeforeAfter } from '../components/BeforeAfter';
import { TomesSection } from '../components/TomesSection';
import { SystemSection } from '../components/SystemSection';
import { BonusesSection } from '../components/BonusesSection';
import { OfferSection } from '../components/OfferSection';
import { Testimonials } from '../components/Testimonials';
import { WhySection } from '../components/WhySection';
import { ImagineSection } from '../components/ImagineSection';
import { AudienceSection } from '../components/AudienceSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { AboutAuthor } from '../components/AboutAuthor';
import { FaqSection } from '../components/FaqSection';
import { FinalCta } from '../components/FinalCta';
import { Footer } from '../components/Footer';
import { FloatingCta } from '../components/FloatingCta';
import { PurchasePopup } from '../components/PurchasePopup';
export function Landing() {
  return <div className="w-full bg-cream" data-id="element-375" data-mp="3peq8kinynaox">
      <Hero data-id="element-376" data-mp="3pfrkepcsw17p" />
      <StatsBar data-id="element-377" data-mp="3pfj74wcrmtvz" />
      <main data-id="element-378" data-mp="3pezyk6909hum">
        <ProblemSection data-id="element-379" data-mp="3pgkuo0ayx8ul" />
        <NoPdfSection data-id="element-380" data-mp="3kfwvusghznpt" />
        <BeforeAfter data-id="element-381" data-mp="3kgoqo129thf1" />
        <TomesSection data-id="element-382" data-mp="3kh7xalmh0jdr" />
        <SystemSection data-id="element-383" data-mp="3khzs3u88ud2z" />
        <BonusesSection data-id="element-384" data-mp="l09us51fdmak" />
        <OfferSection data-id="element-385" data-mp="kzgof56doysy" />
        <Testimonials data-id="element-386" data-mp="kzqestvc57z6" />
        <WhySection data-id="element-387" data-mp="l2ckenyo1der" />
        <ImagineSection data-id="element-388" data-mp="gz6fbjnahs9v" />
        <AudienceSection data-id="element-389" data-mp="gzzikan1hzn9" />
        <GuaranteeSection data-id="element-390" data-mp="gzq0d988kws4" />
        <AboutAuthor data-id="element-391" data-mp="c880yplv3499" />
        <FaqSection data-id="element-392" data-mp="c7oeqwp6htpf" />
        <FinalCta data-id="element-393" data-mp="c76elozeavc8" />
      </main>
      <Footer data-id="element-394" data-mp="c63mxeu90ov9" />
      <FloatingCta data-id="element-395" data-mp="c5vbzshortmp" />
      <PurchasePopup data-id="element-396" data-mp="79mz6lqyocip" />
    </div>;
}